// src/pages/About.jsx
import React from 'react';
import Card3D from '../components/Card3D';

const Hero = ({ title, subtitle, images, backgroundImage, showButtons = true }) => (
  <div className="relative h-screen z-10  overflow-hidden">
    {/* Background Image */}
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage || images[0]})` }}
    >
      <div className="absolute inset-0 bg-black/40"></div>
    </div>

    {/* Content Overlay */}
        <div className="relative z-10 h-full flex items-center text-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="mx-auto max-w-2xl">
              <h1 className="font-inter text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                {title}
              </h1>
              <p className="font-inter text-lg text-gray-200">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
  </div>
)


const About = () => {
  const values = [
    {
      title: 'Professionalism',
      description: 'Having a reputation sustained by consistently providing a high level of real estate service that meets and exceeds expectations',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      )
    },
    {
      title: 'Innovation',
      description: 'Embracing operational patterns and cutting-edge technologies that drive efficiency and improve resource optimization',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      )
    },
    {
      title: 'Expertise',
      description: 'Bringing our experience and extensive market knowledge to provide exceptional, world-class services',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      title: 'Sustainability',
      description: 'Adopting tenets of sustainability in business activities to help maximize long-term business value',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ]

  return (
    <div className="relative min-h-screen overflow-hidden bg-white">

      <div className="relative h-screen bg-cover bg-center" style={{
        backgroundImage: "url('/young-african-american-teamlead-surrounded-by-his-subordinates-pointing-laptops-screen.jpg')",
      }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        
        {/* Content */}
        <div className="relative z-10 h-full flex items-center text-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-2xl mx-auto">
              <h1 className="font-libre text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6"><span className="text-yellow-400">Unlocking opportunities</span> in Africa's high-growth markets<span className="text-yellow-400"></span>
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Mission & Vision Section */}
      <div className="font-inter max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Our Mission */}
          <div className="bg-gray-50 rounded-lg p-8 z-10  hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 font-inter">Our Mission</h2>
            <p className="text-gray-600 leading-relaxed">
              To build a sustainable partnership of Africa's brightest minds and deliver exceptional property solutions to our clients through cutting-edge strategies and innovations.
            </p>
          </div>

          {/* Our Vision */}
          <div className="bg-gray-50 rounded-lg p-8 z-10  hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 font-inter">Our Vision</h2>
            <p className="text-gray-600 leading-relaxed">
              To lead the future of Africa's property consultancy as the most profitable and dynamic firm, driven by pioneering solutions and unparalleled expertise.
            </p>
          </div>
        </div>

        {/* Our Value Section */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-8 font-inter">Our Values</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="bg-white font-inter border border-gray-200 rounded-lg p-6  hover:shadow-lg transition-shadow duration-300 z-10">
                {/* Icon */}
                <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center text-white mb-4">
                  {value.icon}
                </div>
                
                {/* Title */}
                <h3 className="font-inter text-lg font-semibold text-gray-900 mb-3">
                  {value.title}
                </h3>
                
                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className=" rounded-2xl p-12 text-center relative overflow-hidden" style={{ backgroundColor: '#0A1F5C' }}>
          {/* Bottom Left Circle */}
          <div className="absolute bottom-0 left-0 w-40 h-40 border-4 border-white rounded-full -translate-x-28 translate-y-10 opacity-30"></div>

          {/* Top Right Circle */}
          <div className="absolute top-0 right-0 w-40 h-40 border-4 border-white rounded-full translate-x-28 -translate-y-10 opacity-30"></div>

          <div className="relative z-10">
            <h2 className="font-inter font-medium text-3xl md:text-4xl font-bold text-white mb-8">
              Let's Build The Future Together
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4 font-inter">
              <a href="/services">
                <button className="px-8 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors duration-300">
                  Learn More
                </button>
              </a>
              <a href="/contact">
                <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300">
                  Start a Project
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes doodleMove {
          0% { transform: translate(0,0); }
          50% { transform: translate(-20px,-40px); }
          100% { transform: translate(0,0); }
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        .animate-doodleMove {
          animation: doodleMove 90s linear infinite;
        }

        .animate-shimmer {
          animation: shimmer 8s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default About;


